import CroustilleElement from "../lib/CroustilleElement";

class DevelopmentList extends CroustilleElement {
  constructor() {
    super("development-list");
  }

  getInfo(el) {
    const id = el.dataset.id;
    return document.getElementById(id);
  }

  get items() {
    return this.children("item", document);
  }

  get infos() {
    return this.children("info", document);
  }

  handleHover(e) {
    e.stopPropagation();

    this.hideAll();
    const info = this.getInfo(e.currentTarget);
    info.dataset.state = "visible";
    window.lazyloading && window.lazyloading.reset();
  }

  hideAll() {
    this.infos.forEach((info) => (info.dataset.state = "hidden"));
  }

  leave() {
    this.hideAll();
  }

  init() {
    this.handleHover = this.handleHover.bind(this);
    this.leave = this.leave.bind(this);
    this.items.forEach((item) =>
      item.addEventListener("mouseover", this.handleHover)
    );
    this.addEventListener("mouseleave", this.leave);
  }

  destroy() {
    this.items.forEach((item) =>
      item.removeEventListener("mouseover", this.handleHover)
    );
    this.removeEventListener("mouseleave", this.leave);
  }
}

export default DevelopmentList;
